// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useMemo,
// } from "react";
// import { FaSearch } from "react-icons/fa";
// import Cookies from "js-cookie";
// import { getFreshAccessToken } from "../chat/api";
// import api from "../chat/api";
// import { useNavigate } from "react-router-dom";
// import { Header } from "../../components/Header/Header";
// import UploadModal from "../Contract/UploadModal";
// import Filter_for_ocr from "../Ocr_Data/Filter_for_ocr";
// import bell from "../../Images/ai-bell.png";
// import search from "../../Images/search-big.jpg";
// import axios from "axios";
// import "../Contract/contract_data.css";
// import Spinner from "../Contract/Spinner";
// import CustomDropdown from "../Contract/CustomDropdown";
// import useGooglePicker from "./useGooglePicker";
// import { toast } from "react-toastify";
// const ContractTable = ({ isMenuOpen }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkDelete, setIsBulkDelete] = useState(false);
//   const [exportInProgress, setExportInProgress] = useState(false);
//   const [invoices, setinvoices] = useState([]);
//   const [token, setToken] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//   const [editContractId, setEditContractId] = useState(null);
//   const [editedContractData, setEditedContractData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const editRowRef = useRef(null);
//   const [selectedinvoices, setSelectedinvoices] = useState([]);
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const actionMenuRef = useRef(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const [filterType, setFilterType] = useState("");
//   const [timeRange, setTimeRange] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [file, setFile] = useState(null);
//   const fileInputRef = useRef(null);
//   const [selectedFilePreview, setSelectedFilePreview] = useState(null);
//   const { isConnected, connect, disconnect, openPicker, accessToken } =
//     useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [clickedAction, setClickedAction] = useState(null);
//   const [invoice_name, setInvoiceName] = useState("");
//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//     openUpwards: false,
//   });
//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
//   const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
//   const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
//   const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
//   const [selectedTab, setSelectedTab] = useState("manage");
//   const [fieldName, setFieldName] = useState("");
//   const [fieldPrompt, setFieldPrompt] = useState("");
//   const [customFields, setCustomFields] = useState([]);
//   const [loadingAddField, setLoadingAddField] = useState(false);
//   const [deletingField, setDeletingField] = useState(null);
//   const isMaxFieldsReached = customFields.length >= 5;
//   const isFilled = fieldName.trim() && fieldPrompt.trim();
//   const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
//   const moreButtonRef = useRef(null);
//   const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
//   const [isCreatingNew, setIsCreatingNew] = useState(false);
//   const [selectedField, setSelectedField] = useState("");
//   const [newFieldName, setNewFieldName] = useState("");
//   const [newPrompt, setNewPrompt] = useState("");
//   const baseColumns = 7; // name, party A, party B, date, etc.
//   const totalColumns = baseColumns + customFields.length;
//   const uploadButtonRef = useRef(null);

//   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

//   const [customFieldPopup, setCustomFieldPopup] = useState({
//     visible: false,
//     value: "",
//     contractKey: "",
//     contractId: "",
//     x: 0,
//     y: 0,
//   });
//   const popupRef = useRef(null);
//   const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
//   const [isLoading, setIsLoading] = useState(false);
//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files || []);
//     console.log("📁 Files selected in Spreadsheet_data:", selectedFiles);
//     if (selectedFiles.length === 0) return;

//     setFile(selectedFiles); // ✅ save to state
//     setIsModalOpen(true);
//   };
//   const [filterApplied, setFilterApplied] = useState(false);
//   const navigate = useNavigate();
//   const handleFilterApply = (filteredInvoices, filterData) => {
//     setinvoices(filteredInvoices);
//     setIsFilterApplied(true);
//     setFilterType(filterData.filterType);
//     setTimeRange(filterData.timeRange);
//     setFromDate(filterData.fromDate);
//     setToDate(filterData.toDate);
//     toggleFilterModal();
//   };
//   const [filteredFiles, setFilteredFiles] = useState([]);

//   const [selectedFilters, setSelectedFilters] = useState({
//     passport: false,
//     id: false,
//     visa: false,
//     license: false,
//   });

//   useEffect(() => {
//     if (isConnected && !hasOpenedPickerOnce) {
//       // Don't open picker here
//       setHasOpenedPickerOnce(true);
//     }
//   }, [isConnected, hasOpenedPickerOnce]);
//   const handleAddFromDriveClick = () => {
//     openPicker(async (docs) => {
//       console.log("📄 Files picked:", docs);

//       try {
//         const files = await Promise.all(
//           docs.map(async (doc) => {
//             const res = await fetch(
//               `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
//               {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//               }
//             );

//             if (!res.ok) throw new Error("Failed to fetch file from Drive");

//             const blob = await res.blob();
//             return new File([blob], doc.name, { type: blob.type });
//           })
//         );

//         setFile(files); // 👈 trigger your upload flow
//         setIsModalOpen(true); // 👈 open modal
//       } catch (err) {
//         console.error("Failed to process selected files", err);
//         toast.error("Something went wrong while processing selected files.");
//       }
//     });
//   };

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     } else {
//       console.error("Access token missing from cookies");
//     }
//   }, []);

//   const toggleModal = () => {
//     setIsModalOpen((prev) => !prev);
//   };

//   const handleConnectGoogleDrive = async () => {
//     try {
//       console.log("🔄 Attempting to connect to Google Drive...");
//       const token = await getFreshAccessToken();
//       if (!token) throw new Error("No access token found");
//       const response = await axios.get(
//         `http://localhost:8000/api/auth/google-drive/`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("✅ Response from backend:", response);

//       if (response.data && response.data.auth_url) {
//         const fixedRedirectUrl = response.data.auth_url.replace(
//           "http%3A%2F%2Flocalhost%3A8000%2Fapi%2Fauth%2Fgoogle-drive%2Fcallback%2F",
//           encodeURIComponent(
//             "https://stagingbackend.docusensa.com/api/auth/google-drive/callback/"
//           )
//         );

//         console.log("🚀 Redirecting to fixed URL:", fixedRedirectUrl);
//         window.location.href = fixedRedirectUrl;
//       } else {
//         console.warn("⚠️ auth_url not found in response");
//         showPopup("Error", "Invalid response from server.");
//       }
//     } catch (error) {
//       console.error("❌ Failed to connect Google Drive", error);

//       if (error.response) {
//         console.error(
//           "📡 Server responded with error:",
//           error.response.status,
//           error.response.data
//         );
//       } else if (error.request) {
//         console.error("📭 No response received:", error.request);
//       } else {
//         console.error("💥 Error setting up request:", error.message);
//       }

//       showPopup("Error", "Failed to connect Google Drive. Please try again.");
//     }
//   };

//   const handleExport = async () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one invoice to export.");
//       return;
//     }

//     setExportInProgress(true);

//     try {
//       const response = await api.post(
//         `api/v1/idsocr/export-id/`,
//         { id_keys: selectedContractKeys },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "invoices_export.csv");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // showPopup("Success", "Invoices exported successfully.");
//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//       setIsBulkDelete(false);
//     } catch (error) {
//       if (error.response) {
//         const message =
//           error.response.data?.msg || "Failed to export invoices.";
//         showPopup("Error", message);
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setExportInProgress(false);
//     }
//   };

//   const handleCancel = () => {
//     setSelectedinvoices([]);

//     setIsModalOpen(false);
//     setIsFilterModalOpen(false);
//     setPopupVisible(false);

//     setConfirmDeleteVisible(false);
//   };
//   const handleToggleMore = () => {
//     if (isActionMenuOpen === "more") {
//       setIsActionMenuOpen(null);
//     } else {
//       const rect = moreButtonRef.current.getBoundingClientRect();
//       setDropdownCoords({
//         top: rect.bottom + window.scrollY + 6, // Add spacing
//         left: rect.left + window.scrollX, // Align horizontally
//       });
//       setIsActionMenuOpen("more");
//     }
//   };

//   const handleDeleteField = async (fieldId) => {
//     try {
//       await api.delete(`/api/v1/idsocr/delete-field/${fieldId}/`);
//       await fetchCustomFields(); // refresh after deletion
//     } catch (error) {
//       console.error("Error deleting field", error);
//     } finally {
//       setDeletingField(null);
//     }
//   };

//   const handleAddField = async () => {
//     if (!fieldName.trim() || !fieldPrompt.trim()) return;
//     try {
//       setLoadingAddField(true);
//       await api.post("/api/v1/idsocr/create-field/", {
//         field: fieldName.trim(),
//         description: fieldPrompt.trim(),
//       });

//       setFieldName("");
//       setFieldPrompt("");
//       await fetchCustomFields();
//       await fetchinvoices();
//       // show inline success message near button
//       setFieldCreationSuccess(true);

//       setTimeout(() => setFieldCreationSuccess(false), 3000);
//       setSelectedTab("manage");
//       setIsCustomFieldModalOpen(false);
//     } catch (error) {
//       console.error("Error adding field", error);
//     } finally {
//       setLoadingAddField(false);
//     }
//   };

//   const fetchinvoices = useCallback(async () => {
//     if (!token) return;
//     setLoading(true);

//     try {
//       let url = `api/v1/idsocr/ids/`;

//       if (isFilterApplied) {
//         url = `api/v1/invoice/filter-invoice/`;

//         const params = {
//           filter_type: filterType,
//           time_range: timeRange,
//           from_date: fromDate,
//           to_date: toDate,
//         };

//         const response = await api.get(url, { params });
//         setinvoices(response.data.invoices || []);
//       } else {
//         const response = await api.get(url); // clean, no headers needed
//         setinvoices(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching invoices:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

//   const tableBodyRef = useRef(null);

//   const scrollToTop = () => {
//     if (tableBodyRef.current) {
//       tableBodyRef.current.scrollTop = 0;
//     }
//   };

//   const handleSelectAll = () => {
//     if (selectedinvoices.length === invoices.length) {
//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//     } else {
//       setSelectedinvoices(invoices.map((contract) => contract.id));
//       setSelectedContractKeys(invoices.map((contract) => contract.key));
//     }
//   };

//   const filteredinvoices = useMemo(() => {
//     const query = searchQuery?.toLowerCase() || "";
//     return (invoices || []).filter((invoice) => {
//       const invoiceName = invoice?.name?.toLowerCase() || "";
//       const customerName =
//         invoice?.details?.["Customer name"]?.toLowerCase() || "";
//       const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";

//       return (
//         invoiceName.includes(query) ||
//         customerName.includes(query) ||
//         vendorName.includes(query)
//       );
//     });
//   }, [invoices, searchQuery]);

//   const indexOfLastContract = currentPage * rowsPerPage;
//   const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//   const currentinvoices = useMemo(() => {
//     const indexOfLastContract = currentPage * rowsPerPage;
//     const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//     return filteredinvoices.slice(indexOfFirstContract, indexOfLastContract);
//   }, [filteredinvoices, currentPage, rowsPerPage]);

//   const totalPages = useMemo(
//     () => Math.ceil(filteredinvoices.length / rowsPerPage),
//     [filteredinvoices, rowsPerPage]
//   );
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };

//   const handleCheckboxChange = (id, key) => {
//     if (selectedinvoices.includes(id)) {
//       setSelectedinvoices(
//         selectedinvoices.filter((contractId) => contractId !== id)
//       );
//       setSelectedContractKeys(
//         selectedContractKeys.filter((contractKey) => contractKey !== key)
//       );
//     } else {
//       setSelectedinvoices([...selectedinvoices, id]);
//       setSelectedContractKeys([...selectedContractKeys, key]);
//     }
//   };

//   const tbodyRef = useRef(null);
//   useEffect(() => {
//     const calculateRowsPerPage = () => {
//       if (tbodyRef.current) {
//         const containerHeight = tbodyRef.current.clientHeight;

//         const headerHeight = 52; // height of the <thead> row (approx)
//         const rowHeight = 44; // your row height from <tr className="h-[44px]">

//         const visibleHeight = containerHeight - headerHeight;
//         const calculatedRows = Math.floor(visibleHeight / rowHeight);

//         if (calculatedRows > 0) {
//           setRowsPerPage(calculatedRows);
//         }
//       }
//     };

//     calculateRowsPerPage(); // On mount

//     window.addEventListener("resize", calculateRowsPerPage); // On resize

//     return () => window.removeEventListener("resize", calculateRowsPerPage);
//   }, []);

//   useEffect(() => {
//     if (token) {
//       fetchinvoices();
//     }
//   }, [
//     fetchinvoices,
//     token,
//     isFilterApplied,
//     filterType,
//     timeRange,
//     fromDate,
//     toDate,
//   ]);

//   useEffect(() => {
//     if (isFilterApplied) {
//       localStorage.setItem(
//         "invoiceFilter",
//         JSON.stringify({ filterType, timeRange, fromDate, toDate })
//       );
//     }
//   }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

//   // useEffect(() => {
//   //   const storedFilters = JSON.parse(localStorage.getItem("invoiceFilter"));
//   //   if (storedFilters) {
//   //     setFilterType(storedFilters.filterType);
//   //     setTimeRange(storedFilters.timeRange);
//   //     setFromDate(storedFilters.fromDate);
//   //     setToDate(storedFilters.toDate);
//   //     setIsFilterApplied(true);
//   //   }
//   // }, []);

//   const handleUploadSuccess = () => {
//     fetchinvoices();
//     toggleModal();
//   };

//   const handleCloseModal = () => {
//     toggleModal();
//     fetchinvoices();
//   };

//   const handlePageChange = (event) => {
//     const newPage = Number(event.target.value);
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const toggleActionMenu = (index, event) => {
//     const menuHeight = 150; // Approximate height of the action menu
//     const rect = event.currentTarget.getBoundingClientRect();
//     const bottomSpace = window.innerHeight - rect.bottom;

//     const openUpwards = bottomSpace < menuHeight;

//     setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
//     setActionMenuPosition({
//       top: openUpwards ? rect.top - menuHeight : rect.bottom,
//       left: rect.left,
//       openUpwards,
//     });
//   };

//   const toggleFilterModal = () => {
//     setIsFilterModalOpen((prev) => !prev);
//   };

//   const handleViewMore = (invoiceKey) => {
//     navigate(`/Invoices/Invoice_Details/${invoiceKey}`);
//   };

//   const enableEdit = (invoice) => {
//     if (invoice) {
//       setIsActionMenuOpen(null);
//       setEditContractId(invoice.id);

//       const formatDateForInput = (dateString) => {
//         if (!dateString) return "";

//         // Handle DD-MM-YY or MM-DD-YY manually if needed
//         const regex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})$/;
//         const match = dateString.match(regex);

//         if (match) {
//           let [_, part1, part2, part3] = match;

//           // Ensure 4-digit year
//           if (part3.length === 2) {
//             part3 = parseInt(part3) < 50 ? "20" + part3 : "19" + part3;
//           }

//           // Try interpreting both ways
//           const d1 = new Date(`${part3}-${part1}-${part2}`); // yyyy-mm-dd
//           const d2 = new Date(`${part3}-${part2}-${part1}`); // yyyy-dd-mm

//           // Pick the valid one
//           if (!isNaN(d1.getTime()) && d1.getDate() == part2) {
//             return d1.toISOString().split("T")[0];
//           }
//           if (!isNaN(d2.getTime()) && d2.getDate() == part1) {
//             return d2.toISOString().split("T")[0];
//           }
//         }

//         // Try Date object fallback
//         const parsed = new Date(dateString);
//         if (!isNaN(parsed.getTime())) {
//           return parsed.toISOString().split("T")[0];
//         }

//         return ""; // fallback if all fails
//       };

//       const extractAmountAndCurrency = (amount) => {
//         if (!amount) return { value: "", currency: "" };

//         const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/);
//         if (match) {
//           return {
//             currency: match[1].trim(),
//             value: match[2].trim().replace(",", "."),
//           };
//         }
//         return { value: amount, currency: "" };
//       };

//       const { value, currency } = extractAmountAndCurrency(
//         invoice.details?.["Total due amount"]
//       );

//       setEditedContractData({
//         ...invoice,
//         details: {
//           ...invoice.details,
//           DOB: formatDateForInput(invoice.details?.["DOB"]),
//           "Date of issue": formatDateForInput(
//             invoice.details?.["Date of issue"]
//           ),
//           "Date of expiry": formatDateForInput(
//             invoice.details?.["Date of expiry"]
//           ),
//           "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
//           "Due date": formatDateForInput(invoice.details?.["Due date"]),
//           "Total due amount": value,
//           Currency: currency,
//         },
//       });
//       setInvoiceName(invoice.name || "");
//     } else {
//       setEditContractId(null);
//       setEditedContractData({});
//       setInvoiceName("");
//     }
//   };
//   const hasFetched = useRef(false);

//   useEffect(() => {
//     if (!hasFetched.current) {
//       fetchCustomFields();
//       hasFetched.current = true;
//     }
//   }, []);

//   const fetchCustomFields = async () => {
//     try {
//       setCustomFieldsLoading(true);
//       const res = await api.get("/api/v1/idsocr/list-field/");
//       setCustomFields(res.data || []);
//     } catch (err) {
//       console.error("Error fetching fields", err);
//     } finally {
//       setCustomFieldsLoading(false);
//     }
//   };

//   const handleApplyField = async () => {
//     setIsLoading(true);

//     const selectedFieldObj = customFields.find(
//       (field) => field.field === selectedField
//     );

//     const payload = isCreatingNew
//       ? {
//           new_field: {
//             field: newFieldName,
//             description: newPrompt,
//           },
//           doc_keys: selectedContractKeys,
//         }
//       : {
//           field_id: selectedFieldObj?.id,
//           doc_keys: selectedContractKeys,
//         };

//     if (!isCreatingNew && !payload.field_id) {
//       console.error("Invalid field selected.");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const res = await api.post("api/v1/idsocr/apply-field/", payload);
//       console.log("Success:", res.data);
//       setIsCustomApplyFiledModal(false);
//       await fetchinvoices();
//       await fetchCustomFields();

//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//     } catch (err) {
//       console.error("Error:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEditChange = (fieldPath, value) => {
//     if (fieldPath.startsWith("details._custom_fields.")) {
//       const key = fieldPath.split(".")[2];
//       setEditedContractData((prev) => ({
//         ...prev,
//         details: {
//           ...prev.details,
//           _custom_fields: {
//             ...(prev.details?._custom_fields || {}),
//             [key]: value,
//           },
//         },
//       }));
//     } else if (fieldPath.startsWith("details.")) {
//       const key = fieldPath.split(".")[1];
//       setEditedContractData((prev) => ({
//         ...prev,
//         details: {
//           ...prev.details,
//           [key]: value,
//         },
//       }));
//     } else {
//       setEditedContractData((prev) => ({
//         ...prev,
//         [fieldPath]: value,
//       }));
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (
//       actionMenuRef.current &&
//       !actionMenuRef.current.contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }
//     if (
//       confirmDeleteVisible &&
//       event.target.closest(".popup-overlay") === null &&
//       !event.target.closest(".popup-box-delete")
//     ) {
//       setConfirmDeleteVisible(false);
//     }
//   };
//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [confirmDeleteVisible, isActionMenuOpen]);

//   const showPopup = (title, message) => {
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };

//   const closePopup = () => {
//     setPopupVisible(false);
//   };
//   const handleDelete = (contractId) => {
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(false);
//     setContractToDelete(contractId);
//     setConfirmDeleteVisible(true);
//   };

//   const handleBulkDelete = () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one contract to delete.");
//       return;
//     }
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(true);
//     setConfirmDeleteVisible(true);
//   };

//   const handleEditSave = async (invoiceId, invoiceKey) => {
//     const fields = editedContractData.details || {};

//     const editedData = {
//       DOB: fields["DOB"],
//       Name: fields["Name"],
//       "Date of issue": fields["Date of issue"],
//       "Date of expiry": fields["Date of expiry"],
//       Type: fields["Type"],
//       Country: fields["Country"],
//       "Id / Number": fields["Id / Number"],
//       "Issuing Authority": fields["Issuing Authority"],
//       _custom_fields: fields["_custom_fields"] || {},
//     };

//     const payload = {
//       edited_data: editedData,
//     };

//     // 🔥 Only add id_name if the name was changed
//     if (invoice_name && invoice_name !== editedContractData.name) {
//       payload.id_name = invoice_name;
//     }

//     try {
//       const response = await api.post(
//         `/api/v1/idsocr/edit-id-details/${invoiceKey}/`,
//         payload
//       );

//       if (response.status === 200) {
//         const updated = response.data.data;

//         setinvoices((prev) =>
//           prev.map((inv) =>
//             inv.id === invoiceId
//               ? { ...inv, name: invoice_name, details: updated }
//               : inv
//           )
//         );

//         setEditContractId(null);
//         setRenameSuccessRowId(invoiceId);
//         setTimeout(() => setRenameSuccessRowId(null), 3000);
//       }
//     } catch (error) {
//       console.error("Edit failed:", error);
//       showPopup("Error", "Failed to update ID. Please try again.");
//     }
//   };

//   const confirmDelete = async () => {
//     const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];

//     setDeleteInProgress(true);

//     try {
//       const response = await api.delete(`api/v1/idsocr/id-delete/`, {
//         data: { document_ids: idsToDelete },
//       });

//       const { Deleted_invoices = [], Failed_deletions = [] } = response.data;

//       if (Deleted_invoices.length > 0) {
//         setinvoices((previnvoices) =>
//           previnvoices.filter(
//             (invoice) => !Deleted_invoices.includes(invoice.id)
//           )
//         );

//         if (isBulkDelete) {
//           setSelectedinvoices([]);
//           setSelectedContractKeys([]);
//         }
//       }

//       if (Failed_deletions.length > 0) {
//         const failureMessages = Failed_deletions.map(
//           (failure) => `Invoice ID ${failure.invoice_id}: ${failure.error}`
//         ).join("\n");
//         showPopup("Deletion Failed", failureMessages);
//       }
//     } catch (error) {
//       console.error("Error deleting invoices:", error);
//       showPopup("Error", "Failed to delete invoice(s). Please try again.");
//     } finally {
//       setDeleteInProgress(false);
//       setConfirmDeleteVisible(false); // 👈 Close modal
//       setIsBulkDelete(false); // 👈 Reset bulk delete flag
//       setContractToDelete(null); // 👈 Clear single delete state
//       fetchinvoices();
//     }
//   };

//   useEffect(() => {
//     if (editContractId) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [editContractId]);
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

//   return (
//     <>
//       {loading && <Spinner />}
//       <div className="full-container max-w-full overflow-x-hidden">
//         <div className="">
//           <Header
//             name="Identity Extraction"
//             icon={""}
//             isMenuOpen={isMenuOpen}
//           />
//         </div>

//         <div
//           className="contract-table-container  overflow-x-hidden"
//           style={{ marginLeft: isMenuOpen ? "226px" : "120px" }}
//         >
//           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[3px]">
//             {/* LEFT: Search & Filter */}
//             <div className="flex items-center gap-1 min-w-[300px]">
//               {/* Search */}
//               <div
//                 style={{
//                   display: "flex",
//                   width: "310px",
//                   height: "40px",
//                   padding: "8px 20px 8px 26px", // ← increased left padding
//                   alignItems: "center",
//                   gap: "1px",
//                   flexShrink: 0,
//                   borderRadius: "20px",
//                   border: isSearchFocused
//                     ? "1px solid rgba(187, 66, 174, 0.36)"
//                     : "1px solid rgba(0, 0, 0, 0.10)",
//                   backgroundColor: "#FFF",
//                   boxShadow: isSearchFocused
//                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
//                     : "none",
//                   overflow: "hidden",
//                 }}
//               >
//                 <img
//                   src="/search.svg"
//                   alt="Search"
//                   style={{
//                     width: "24px",
//                     height: "24px",
//                     flexShrink: 0,
//                     marginRight: "4px", // ← extra spacing between icon and input
//                   }}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Search Identity Here"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   onFocus={() => setIsSearchFocused(true)}
//                   onBlur={() => setIsSearchFocused(false)}
//                   style={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     fontStyle: "normal",
//                     fontWeight: 400,
//                     lineHeight: "normal",
//                     border: "none",
//                     outline: "none",
//                     width: "100%",
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     color: "#171717",
//                   }}
//                 />
//               </div>

//               {/* Filter */}
//               <button
//                 className={`filter-button-new ${
//                   isFilterApplied ? "filter-applieds" : ""
//                 }`}
//                 onClick={toggleFilterModal}
//               >
//                 <img
//                   src={isFilterApplied ? "/Filter_CTA.png" : "/filter.svg"}
//                   alt="Filter Icon"
//                 />
//               </button>
//             </div>

//             {/* RIGHT: Custom field, Upload, Bulk Actions */}
//             <div className="flex items-center gap-3 flex-wrap justify-end">
//               {selectedinvoices.length > 0 ? (
//                 <>
//                   <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1 rounded-full font-medium">
//                     {selectedinvoices.length} Invoice selected
//                   </span>

//                   <button
//                     className="bg-[#7F56D9] text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#6941C6] transition"
//                     onClick={() => setIsCustomApplyFiledModal(true)}
//                   >
//                     <span className="text-white">Apply Custom Field</span>
//                   </button>

//                   {/* More Dropdown */}
//                   <div className="relative">
//                     <button
//                       ref={moreButtonRef}
//                       onClick={handleToggleMore}
//                       className="border border-[#D0D5DD] text-[#344054] text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2 hover:bg-gray-50"
//                     >
//                       More
//                       <svg
//                         className="w-4 h-4"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth={2}
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </button>

//                     {isActionMenuOpen === "more" && (
//                       <div
//                         className="fixed z-[9999] w-35 bg-white border border-gray-200 rounded-md shadow-md py-1 p-1"
//                         style={{
//                           top: `${dropdownCoords.top}px`,
//                           left: `${dropdownCoords.left}px`,
//                         }}
//                       >
//                         {/* Export */}
//                         <button
//                           onClick={handleExport}
//                           disabled={exportInProgress}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-purple-100 text-[#8B55DD] disabled:opacity-50"
//                         >
//                           <img
//                             src="/export-icon-blue.svg"
//                             className="w-4 h-4"
//                           />
//                           {exportInProgress ? "Exporting..." : "Export"}
//                         </button>

//                         {/* Delete */}
//                         <button
//                           onClick={handleBulkDelete}
//                           className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-red-100 text-red-600"
//                         >
//                           <img src="/delete-icon-red.svg" className="w-4 h-4" />
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </div>

//                   {/* Cancel */}
//                   <button onClick={handleCancel} className="ml-2">
//                     <img
//                       src="/cancel_icon.svg"
//                       alt="Cancel"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <button
//                     className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design"
//                     onClick={() => setIsCustomFieldModalOpen(true)}
//                   >
//                     <img src="/custom-field-icons.svg" className="w-5 h-5" />
//                     <span className="new-custom-butons-design-text">
//                       Custom Field
//                     </span>
//                   </button>

//                   <div className="relative">
//                     <button
//                       ref={uploadButtonRef}
//                       className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
//                       onClick={() => setIsTooltipVisible(!isTooltipVisible)}
//                       onMouseEnter={() => {
//                         if (uploadButtonRef.current) {
//                           const rect =
//                             uploadButtonRef.current.getBoundingClientRect();
//                           setTooltipCoords({
//                             top: rect.top + window.scrollY + 45,
//                             left: rect.left + window.scrollX + rect.width - 140,
//                           });
//                         }
//                       }}
//                     >
//                       <img src="/upload_icon_white.svg" className="w-5 h-5" />
//                       <span className="new-custom-butons-design-texts">
//                         Upload
//                       </span>
//                     </button>

//                     {/* Tooltip dropdown with options */}
//                     {isTooltipVisible && (
//                       <div
//                         className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
//                         style={{
//                           top: `${tooltipCoords.top + 10}px`,
//                           left: `${tooltipCoords.left - 50}px`,
//                         }}
//                         onMouseLeave={() => setIsTooltipVisible(false)}
//                       >
//                         {/* Upload from Device */}
//                         <div
//                           className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                           onClick={() => {
//                             setIsTooltipVisible(false);
//                             fileInputRef.current.click();
//                           }}
//                         >
//                           <img
//                             src="/upload-icon.svg"
//                             alt="Upload"
//                             className="w-4 h-4"
//                           />
//                           Add from device
//                         </div>

//                         {/* Connect Google Drive */}
//                         {!isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onClick={() => {
//                               setIsTooltipVisible(false);
//                               navigate("/account/integration");
//                             }}
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/connect-icon-hover.svg"
//                                   : "/connect-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />{" "}
//                             Connect Drive
//                           </div>
//                         )}

//                         {isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                             onClick={handleAddFromDriveClick} // Trigger the picker on click
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/picker-icon-hover.svg"
//                                   : "/picker-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />
//                             Add from Drive
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       className="hidden"
//                       accept=".pdf,.jpeg,.jpg,.png"
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           <div
//             className={`overflow-x-auto  transition-all duration-300 mt-2`}
//             style={{
//               width: isMenuOpen ? "calc(100vw - 320px)" : "calc(100vw - 158px)",
//             }}
//           >
//             <div className="overflow-x-auto w-[100%]  mb-4">
//               <div
//                 className="relative overflow-x-auto  custom-scrollbar-container"
//                 style={{
//                   height: "calc(100vh - 180px)", // Adjust height as needed
//                 }}
//                 ref={tbodyRef}
//               >
//                 <table
//                   className="text-sm text-left table-auto"
//                   style={{ minWidth: `${totalColumns * 14.29}%` }}
//                 >
//                   <thead className="bg-[#FFF] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
//                     <tr>
//                       <th className="sticky-col sticky-col-1  w-[40px] px-3 bg-white">
//                         <input
//                           type="checkbox"
//                           className="custom-checkbox"
//                           style={{
//                             appearance: "none",
//                             // width: "16px",
//                             // height: "16px",
//                             border: "1.5px solid #c0c0c0",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                             backgroundImage:
//                               selectedinvoices.length === invoices.length &&
//                               invoices.length > 0
//                                 ? "url('/checck.svg')"
//                                 : "none",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                             backgroundSize: "20px 20px",
//                           }}
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedinvoices.length === invoices.length &&
//                             invoices.length > 0
//                           }
//                         />
//                       </th>

//                       <th className="sticky-col sticky-col-2 min-w-[130px] px-1 file-size-of-heading">
//                         File Name
//                       </th>
//                       <th className="sticky-col sticky-col-3 min-w-[130px] px-3 file-size-of-heading bg-white z-10">
//                         Type
//                       </th>
//                       <th className="min-w-[180px] px-3 file-size-of-heading">
//                         Country
//                       </th>

//                       <th className="min-w-[170px] px-3 file-size-of-heading">
//                         Issuing Authority
//                       </th>
//                       {customFields.map((field, index) => (
//                         <th
//                           key={index}
//                           className="min-w-[120px] px-3 file-size-of-headings"
//                         >
//                           <span className="inline-flex items-baseline gap-1">
//                             {field.field}{" "}
//                             <img
//                               src="/invoice-bulblogo-invoicee.svg"
//                               alt="Bullet Icon"
//                               className="ml-1 translate-y-[-2px]" // slightly lifted
//                             />
//                           </span>
//                         </th>
//                       ))}
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         ID Number
//                       </th>
//                       <th className="min-w-[170px] px-3 file-size-of-heading">
//                         Name
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         DOB
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Date of Issue
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Date of Expiry
//                       </th>
//                       <th className="min-w-[130px] px-3 file-size-of-heading">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody
//                     className={
//                       currentinvoices.length > rowsPerPage ? "scrollable" : ""
//                     }
//                     style={{
//                       overflowY:
//                         currentinvoices.length > rowsPerPage
//                           ? "auto"
//                           : "hidden",
//                       maxHeight: "400px",
//                       backgroundColor: "#FFF",
//                     }}
//                   >
//                     {loading ? (
//                       <tr>
//                         <td colSpan="6" style={{ textAlign: "center" }}>
//                           <Spinner />
//                         </td>
//                       </tr>
//                     ) : invoices.length > 0 ? (
//                       currentinvoices.map((contract, index) => (
//                         <tr
//                           key={index}
//                           ref={
//                             editContractId === contract.id ? editRowRef : null
//                           }
//                           style={{
//                             background:
//                               hoveredRow === index ? "#F8F3FF" : "transparent",
//                             boxShadow:
//                               hoveredRow === index
//                                 ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
//                                 : "none",
//                           }}
//                           onMouseEnter={() => setHoveredRow(index)}
//                           onMouseLeave={() => setHoveredRow(null)}
//                           className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
//                         >
//                           <td className="sticky-col sticky-col-1 px-3 bg-white z-20">
//                             <input
//                               type="checkbox"
//                               className="custom-checkbox"
//                               style={{
//                                 appearance: "none",
//                                 // width: "16px",
//                                 // height: "16px",
//                                 border: "1.5px solid #c0c0c0",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                                 backgroundImage: selectedinvoices.includes(
//                                   contract.id
//                                 )
//                                   ? "url('/checck.svg')"
//                                   : "none",
//                                 backgroundPosition: "center",
//                                 backgroundRepeat: "no-repeat",
//                                 backgroundSize: "20px 20px",
//                               }}
//                               checked={selectedinvoices.includes(contract.id)}
//                               onChange={() =>
//                                 handleCheckboxChange(contract.id, contract.key)
//                               }
//                             />
//                           </td>

//                           {editContractId === contract.id ? (
//                             <>
//                               <td className="sticky left-[40px]">
//                                 <input
//                                   type="text"
//                                   value={invoice_name}
//                                   onChange={(e) =>
//                                     setInvoiceName(e.target.value)
//                                   }
//                                   className="edit-contract-name-ocr"
//                                   placeholder="Enter Invoice Name"
//                                 />
//                               </td>

//                               <td className="sticky-col sticky-col-3">
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.["Type"] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Type",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocrs"
//                                   placeholder="Enter Document Type"
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.["Country"] ||
//                                     ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Country",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocr"
//                                   placeholder="Enter Country"
//                                 />
//                               </td>

//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Issuing Authority"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Issuing Authority",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocr"
//                                   placeholder="Enter Issuing Authority"
//                                 />
//                               </td>

//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field;
//                                 return (
//                                   <td
//                                     key={index}
//                                     className="file-size-of-subheading"
//                                   >
//                                     <input
//                                       type="text"
//                                       value={
//                                         editedContractData.details
//                                           ?._custom_fields?.[fieldKey] || ""
//                                       }
//                                       onChange={(e) =>
//                                         handleEditChange(
//                                           `details._custom_fields.${fieldKey}`,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="edit-contract"
//                                     />
//                                   </td>
//                                 );
//                               })}
//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Id / Number"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Id / Number",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocr"
//                                   placeholder="Enter ID / Number"
//                                 />
//                               </td>

//                               <td>
//                                 <input
//                                   type="text"
//                                   value={
//                                     editedContractData.details?.["Name"] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Name",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocr"
//                                   placeholder="Enter Name"
//                                 />
//                               </td>

//                               <td>
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.["DOB"] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.DOB",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocrs"
//                                   placeholder="Select DOB"
//                                 />
//                               </td>

//                               <td>
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Date of issue"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Date of issue",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocrs"
//                                   placeholder="Select Date of Issue"
//                                 />
//                               </td>
//                               <td>
//                                 <input
//                                   type="date"
//                                   value={
//                                     editedContractData.details?.[
//                                       "Date of expiry"
//                                     ] || ""
//                                   }
//                                   onChange={(e) =>
//                                     handleEditChange(
//                                       "details.Date of expiry",
//                                       e.target.value
//                                     )
//                                   }
//                                   className="edit-contract-name-ocrs"
//                                   placeholder="Select Date of Expiry"
//                                 />
//                               </td>

//                               <td className="action-icons-contract">
//                                 <button
//                                   onClick={() =>
//                                     handleEditSave(contract.id, contract.key)
//                                   }
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/save-icon-contracttable.svg"
//                                     alt="Save"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                                 <button
//                                   onClick={() => setEditContractId(null)}
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/cancel-icon-contracttable.svg"
//                                     alt="Cancel"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                               </td>
//                             </>
//                           ) : (
//                             <>
//                               <td className="sticky left-[40px] z-[20] bg-white px-1 min-w-[130px]">
//                                 <div className="relative group cursor-pointer text-[#B793ED] underline">
//                                   <span
//                                     className="truncate inline-block max-w-[120px] underline cursor-pointer"
//                                     onClick={() =>
//                                       setSelectedFilePreview(contract)
//                                     }
//                                   >
//                                     {contract.name?.length > 25
//                                       ? `${contract.name.slice(
//                                           0,
//                                           40
//                                         )}...${contract.name.slice(-5)}`
//                                       : contract.name || "N/A"}
//                                   </span>

//                                   {/* Tooltip */}
//                                   <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:flex px-3 py-1 text-sm bg-white text-gray-900 border border-gray-200 shadow-md rounded-md z-50 whitespace-nowrap">
//                                     {contract.name || "N/A"}
//                                   </div>

//                                   {/* Optional success bubble */}
//                                   {renameSuccessRowId === contract.id && (
//                                     <div className="fixed top-[400px] left-1/2 transform -translate-x-1/2 z-50 inline-flex items-center gap-2 px-4 py-2 h-[40px] rounded-md border border-gray-200 bg-white shadow-md text-sm text-gray-700">
//                                       <img
//                                         src="/green-icon-tick.svg"
//                                         alt="Success"
//                                         className="w-5 h-5"
//                                       />
//                                       <span>Your changes were applied</span>
//                                     </div>
//                                   )}
//                                 </div>
//                               </td>

//                               <td className="sticky-col sticky-col-3 px-3 file-size-of-subheading bg-white z-10">
//                                 {contract.details?.["Type"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Country"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Issuing Authority"] ||
//                                   "N/A"}
//                               </td>
//                               {customFields.map((fieldObj, index) => {
//                                 const fieldKey = fieldObj.field; // actual key used in _custom_fields
//                                 const fieldValue =
//                                   contract.details?._custom_fields?.[
//                                     fieldKey
//                                   ] || "N/A";
//                                 const isValid =
//                                   fieldValue && fieldValue !== "null";

//                                 return (
//                                   <td
//                                     key={index}
//                                     className="px-3 file-size-of-subheadin"
//                                   >
//                                     <span
//                                       className="text-[#B793ED] cursor-pointer inline-block max-w-[140px] truncate"
//                                       onMouseEnter={(e) => {
//                                         const rect =
//                                           e.currentTarget.getBoundingClientRect();
//                                         setCustomFieldPopup({
//                                           visible: true,
//                                           value: fieldValue,
//                                           contractKey: contract.key,
//                                           contractId: contract.id,
//                                           x: rect.left + window.scrollX,
//                                           y: rect.bottom + window.scrollY + 8,
//                                         });
//                                       }}
//                                       onMouseLeave={(e) => {
//                                         // Start timeout that allows user to move to popup
//                                         setTimeout(() => {
//                                           if (
//                                             popupRef.current &&
//                                             !popupRef.current.matches(":hover")
//                                           ) {
//                                             setCustomFieldPopup((prev) => ({
//                                               ...prev,
//                                               visible: false,
//                                             }));
//                                           }
//                                         }, 150);
//                                       }}
//                                     >
//                                       {fieldValue.length > 10
//                                         ? `${fieldValue.slice(0, 10)}...`
//                                         : fieldValue}
//                                     </span>
//                                   </td>
//                                 );
//                               })}
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Id / Number"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Name"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["DOB"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Date of issue"] || "N/A"}
//                               </td>
//                               <td className="px-3 file-size-of-subheading">
//                                 {contract.details?.["Date of expiry"] || "N/A"}
//                               </td>

//                               <td className="px-3 ">
//                                 <img
//                                   src="./action.svg"
//                                   alt="Actions"
//                                   width="20"
//                                   height="20"
//                                   onClick={(e) => toggleActionMenu(index, e)}
//                                   style={{ cursor: "pointer" }}
//                                 />
//                                 {isActionMenuOpen === index && (
//                                   <div
//                                     className="action-menu"
//                                     style={{
//                                       position: "fixed",
//                                       top: actionMenuPosition.openUpwards
//                                         ? `${actionMenuPosition.top}px`
//                                         : `${actionMenuPosition.top}px`,
//                                       left: `${
//                                         actionMenuPosition.left - 215
//                                       }px`,
//                                       transform: actionMenuPosition.openUpwards
//                                         ? "translateY(50%)"
//                                         : "none", // If openUpwards, shift the menu upward
//                                       zIndex: 9999,
//                                     }}
//                                     ref={actionMenuRef}
//                                   >
//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("edit")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("edit")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => enableEdit(contract)}
//                                       style={{
//                                         color:
//                                           clickedAction === "edit"
//                                             ? "#C95EBE"
//                                             : hoveredAction === "edit"
//                                             ? "#C95EBE"
//                                             : "#000",
//                                         transition:
//                                           "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "edit" ||
//                                           hoveredAction === "edit"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                         padding: "10px",
//                                         cursor: "pointer",
//                                         width: "8.2rem",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : hoveredAction === "edit"
//                                             ? "./edit-active-contract.svg"
//                                             : "./edit.svg"
//                                         }
//                                         alt="Edit Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Edit</p>
//                                     </div>

//                                     <div
//                                       className="action-item"
//                                       onMouseEnter={() =>
//                                         setHoveredAction("delete")
//                                       }
//                                       onMouseLeave={() =>
//                                         setHoveredAction(null)
//                                       }
//                                       onMouseDown={() =>
//                                         setClickedAction("delete")
//                                       }
//                                       onMouseUp={() => setClickedAction(null)}
//                                       onClick={() => handleDelete(contract.id)}
//                                       style={{
//                                         color:
//                                           clickedAction === "delete"
//                                             ? "rgba(226, 25, 25, 0.75)"
//                                             : hoveredAction === "delete"
//                                             ? "rgba(226, 25, 25, 0.75)"
//                                             : "#000",
//                                         transition:
//                                           "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                         borderRadius: "8px",
//                                         border:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "none"
//                                             : "none",
//                                         background:
//                                           clickedAction === "delete" ||
//                                           hoveredAction === "delete"
//                                             ? "#FAF9F6"
//                                             : "transparent",
//                                         padding: "10px",
//                                         cursor: "pointer",
//                                         width: "8.2rem",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           clickedAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : hoveredAction === "delete"
//                                             ? "./delete-active-contract.svg"
//                                             : "./delete.svg"
//                                         }
//                                         alt="Delete Icon"
//                                         className="action-icon"
//                                       />
//                                       <p>Delete</p>
//                                     </div>
//                                   </div>
//                                 )}
//                               </td>
//                             </>
//                           )}
//                         </tr>
//                       ))
//                     ) : (
//                       <tr className="h-[44px] text-center">
//                         <td colSpan="7" className="py-6 text-black-400">
//                           <img
//                             src="/no-contracts.svg"
//                             alt="No Data"
//                             className="mx-auto mb-2"
//                           />
//                           <p className="text-[16px]">
//                             Looks like your table is empty!
//                           </p>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {invoices.length > 0 && (
//                 <div className="pagination-doc">
//                   <div className="pagination-dropdown">
//                     <p className="page-selector">{currentPage}</p>
//                   </div>
//                   <p className="contentDown">of {totalPages} pages</p>
//                   <button
//                     onClick={handlePreviousPage}
//                     disabled={currentPage === 1}
//                     style={{
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="decrease.svg"
//                       alt="Previous Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                   <button
//                     onClick={handleNextPage}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="increase.svg"
//                       alt="Next Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {popupVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box">
//               <h2>{popupTitle}</h2>
//               <p>{popupMessage}</p>
//               <button onClick={closePopup} className="popup-close-button">
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box-delete">
//               <h2>Are you sure you want to delete the selected spreadsheet?</h2>
//               <p>
//                 {isBulkDelete
//                   ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
//                   : "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setConfirmDeleteVisible(false)}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-delete"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-button"
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         <UploadModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onUploadSuccess={handleUploadSuccess}
//           type={"ocr"}
//           file={file}
//         />

//         <Filter_for_ocr
//           isOpen={isFilterModalOpen}
//           onClose={() => setIsFilterModalOpen(false)}
//           onApply={(filteredResponse) => {
//             // filteredResponse is { documents: [...] }
//             setinvoices(filteredResponse.documents); // ✅ Update table data
//             setFilteredFiles(filteredResponse.documents); // optional
//             setIsFilterApplied(true);
//             setCurrentPage(1); // reset to page 1
//           }}
//           onClear={(cleared) => {
//             setIsFilterApplied(false); // ✅ Main toggle
//             setinvoices(cleared?.documents || []);
//             setCurrentPage(1);
//           }}
//           setIsFilterApplied={setIsFilterApplied}
//           selectedFilters={selectedFilters}
//           setSelectedFilters={setSelectedFilters}
//         />

//         {isCustomApplyFieldModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//             <div
//               className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] pt-[18px] pl-[24px] pr-[24px] pb-[24px]"
//               style={{
//                 boxShadow:
//                   "130px 189px 64px rgba(0, 0, 0, 0.00), 83px 121px 59px rgba(0, 0, 0, 0.01), 47px 68px 50px rgba(0, 0, 0, 0.05), 21px 30px 37px rgba(0, 0, 0, 0.09), 5px 8px 20px rgba(0, 0, 0, 0.10)",
//               }}
//             >
//               <div className="flex justify-between items-center">
//                 <h2 className="apply-heading-cutom">Apply Custom Field</h2>
//                 <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1">
//                   {selectedinvoices.length} Contracts selected
//                 </span>
//                 <span
//                   onClick={() => setIsCustomApplyFiledModal(false)}
//                   className="cursor-pointer text-xl"
//                 >
//                   ×
//                 </span>
//               </div>

//               <div className="flex gap-8 mt-[20px] items-start">
//                 {/* Option 1: Select Existing */}
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input
//                     type="radio"
//                     checked={!isCreatingNew}
//                     onChange={() => setIsCreatingNew(false)}
//                     className="accent-[#7F56D9] w-4 h-4"
//                   />
//                   <span className="apply-dot-heading">
//                     Select from Existing Field
//                   </span>
//                 </label>

//                 {/* Option 2: Create New Field + (2/5 used) below it */}
//                 <label className="flex flex-col cursor-pointer">
//                   <div className="flex items-center gap-2">
//                     <input
//                       type="radio"
//                       checked={isCreatingNew}
//                       onChange={() => setIsCreatingNew(true)}
//                       className="accent-[#7F56D9] w-4 h-4"
//                     />
//                     <span className="apply-dot-heading">Create New Field</span>
//                   </div>
//                   <span className="text-xs text-[#999] ml-6">
//                     ({customFields.length}/5 used)
//                   </span>
//                 </label>
//               </div>

//               {isCreatingNew ? (
//                 <>
//                   <label className="apply-dot-heading">Field Name</label>
//                   <input
//                     className="apply-input-field pl-2 mt-1"
//                     placeholder="Enter your field name here"
//                     value={newFieldName}
//                     onChange={(e) => setNewFieldName(e.target.value)}
//                   />
//                   <label className="apply-dot-heading mt-2">
//                     Extraction Prompt
//                   </label>
//                   <textarea
//                     className="apply-input-field-design-here pl-2 pt-1 pr-1 mt-1"
//                     placeholder="Enter your Extraction Prompts here"
//                     value={newPrompt}
//                     onChange={(e) => setNewPrompt(e.target.value)}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <label className="apply-dot-heading">Choose Field</label>
//                   <CustomDropdown
//                     selected={selectedField}
//                     onSelect={setSelectedField}
//                     options={customFields.map((field) => field.field)}
//                   />
//                 </>
//               )}

//               <div className="absolute bottom-4 right-4 flex justify-end gap-3">
//                 <button
//                   className="cancel-apply-button-design"
//                   onClick={() => setIsCustomApplyFiledModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleApplyField}
//                   className={`apply-apply-button ${
//                     isLoading
//                       ? "bg-[#D081D9]"
//                       : "bg-[#D081D9] hover:bg-[#C26ED2]"
//                   }`}
//                 >
//                   {isLoading ? (
//                     <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                   ) : isCreatingNew ? (
//                     "Create & Apply"
//                   ) : (
//                     "Apply Field"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {isCustomFieldModalOpen && (
//           <div className="custom-modal-overlay-inline show">
//             <div className="custom-modal-content-custom active relative">
//               <button
//                 className="close-modal-custom"
//                 onClick={() => setIsCustomFieldModalOpen(false)}
//               >
//                 ×
//               </button>

//               <h2 className="custom-modal-title-custom">Custom Fields</h2>
//               <p className="custom-modal-subtitle-custom">
//                 You can only create up to 5 custom fields per document.
//                 <br />
//                 Deleting a field won’t reset the limit.
//               </p>

//               <div className="custom-modal-tabs-custom">
//                 <button
//                   className={`manage-btn-custom ${
//                     selectedTab === "manage" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("manage")}
//                 >
//                   {customFieldsLoading
//                     ? "Loading..."
//                     : `Manage Existing Fields (${customFields.length}/5)`}
//                 </button>
//                 <button
//                   className={`create-btn-custom ${
//                     selectedTab === "create" ? "active" : ""
//                   }`}
//                   onClick={() => setSelectedTab("create")}
//                 >
//                   Create New Field
//                 </button>
//               </div>

//               {selectedTab === "create" && (
//                 <>
//                   <label className="field-label-custom">
//                     Field name{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <input
//                     type="text"
//                     className="input-field-custom"
//                     value={fieldName}
//                     onChange={(e) => setFieldName(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Maximum 3 fields allowed. Please delete one to add new."
//                         : "Enter your field name here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <label className="field-label-custom">
//                     Extraction Prompt{" "}
//                     <img
//                       src="/bulb.svg"
//                       alt="Hint"
//                       className="label-icon-custom"
//                     />
//                   </label>
//                   <textarea
//                     className="textarea-field-custom"
//                     value={fieldPrompt}
//                     onChange={(e) => setFieldPrompt(e.target.value)}
//                     placeholder={
//                       isMaxFieldsReached
//                         ? "Cannot enter prompt. Maximum limit reached."
//                         : "Enter your Extraction Prompts here"
//                     }
//                     disabled={isMaxFieldsReached}
//                   />
//                   <button
//                     className={`add-field-btn-custom ${
//                       isFilled && !loadingAddField && !isMaxFieldsReached
//                         ? "active"
//                         : ""
//                     }`}
//                     onClick={handleAddField}
//                     disabled={loadingAddField || isMaxFieldsReached}
//                   >
//                     {loadingAddField ? "Adding..." : "Add Field"}
//                   </button>
//                 </>
//               )}

//               {selectedTab === "manage" && (
//                 <div>
//                   <div className="manage-fields-placeholder mt-[20px] max-h-[222px] overflow-y-auto mr-2">
//                     <div className="flex mt-2 gap-[60px]">
//                       <h2 className="field-name-custom">Field Name</h2>
//                       <h2 className="field-name-custom">Prompt</h2>
//                     </div>
//                     {customFields.length ? (
//                       customFields.map((field, index) => (
//                         <div key={index}>
//                           <div className="flex items-start gap-[26px] mt-[12px]">
//                             <p className="text-[#1A1A1A] text-sm font-medium w-[109px] whitespace-nowrap">
//                               {field.field}
//                             </p>
//                             <p className="text-[#1A1A1A] text-sm w-[139px]">
//                               {field.description}
//                             </p>
//                             <button
//                               className="button-red-custom-field"
//                               onClick={() => {
//                                 setDeletingField(field.id);
//                                 handleDeleteField(field.id);
//                               }}
//                               disabled={deletingField === field.id}
//                             >
//                               {deletingField === field.id
//                                 ? "Deleting"
//                                 : "Delete"}
//                               <img src="/delete-icon-red.svg" alt="Delete" />
//                             </button>
//                           </div>
//                           <div className="my-4 mt-[20px] border-[#EAEAEA] hr-line-divider"></div>
//                         </div>
//                       ))
//                     ) : (
//                       <p className="text-sm text-gray-500 ml-2 mt-3">
//                         No custom fields available.
//                       </p>
//                     )}
//                   </div>

//                   <button
//                     className="add-field-btn-custom-twos absolute bottom-4 right-4"
//                     onClick={async () => {
//                       await fetchinvoices(); // refresh table to show new field
//                       setIsCustomFieldModalOpen(false);
//                     }}
//                   >
//                     Done
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//         {customFieldPopup.visible && (
//           <div
//             ref={popupRef}
//             className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
//             style={{
//               top: `${customFieldPopup.y}px`,
//               left: `${customFieldPopup.x}px`,
//               maxWidth: "300px",
//               width: "max-content",
//               whiteSpace: "normal",
//             }}
//             onMouseEnter={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
//             }
//             onMouseLeave={() =>
//               setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
//             }
//           >
//             <p className="text-gray-800 text-sm font-medium break-words">
//               {customFieldPopup.value.length > 80
//                 ? `${customFieldPopup.value.slice(0, 80)}...`
//                 : customFieldPopup.value}
//             </p>
//             {/* <button
//       onClick={() =>
//         handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)
//       }
//       className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
//     >
//       View More
//     </button> */}
//           </div>
//         )}

//         {selectedFilePreview && (
//           <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
//             onClick={() => setSelectedFilePreview(null)}
//           >
//             <div
//               className="bg-white rounded-lg shadow-lg w-[40vw] h-[55vh] overflow-hidden relative"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Full Preview */}
//               {selectedFilePreview.file_type === "pdf" ? (
//                 <embed
//                   src={selectedFilePreview.pdf_url}
//                   type="application/pdf"
//                   className="w-full h-full"
//                 />
//               ) : (
//                 <img
//                   src={selectedFilePreview.pdf_url}
//                   alt={selectedFilePreview.name}
//                   className="w-full h-full object-contain"
//                 />
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default ContractTable;

import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch } from "react-icons/fa";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../chat/api";
import api from "../chat/api";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import Filter_for_ocr from "../Ocr_Data/Filter_for_ocr";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import axios from "axios";
import "../Contract/contract_data.css";
import Spinner from "../Contract/Spinner";
import CustomDropdown from "../Contract/CustomDropdown";
import useGooglePicker from "./useGooglePicker";
import { toast } from "../../utils/appToast";

const ContractTable = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [token, setToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedinvoices, setSelectedinvoices] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedFilePreview, setSelectedFilePreview] = useState(null);
  const { isConnected, connect, disconnect, openPicker, accessToken } =
    useGooglePicker();
  const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [invoice_name, setInvoiceName] = useState("");
  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
    openUpwards: false,
  });
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
  const [isCustomApplyFieldModal, setIsCustomApplyFiledModal] = useState(false);
  const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
  const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("manage");
  const [fieldName, setFieldName] = useState("");
  const [fieldPrompt, setFieldPrompt] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [loadingAddField, setLoadingAddField] = useState(false);
  const [deletingField, setDeletingField] = useState(null);
  const isMaxFieldsReached = customFields.length >= 5;
  const isFilled = fieldName.trim() && fieldPrompt.trim();
  const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
  const moreButtonRef = useRef(null);
  const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [newFieldName, setNewFieldName] = useState("");
  const [newPrompt, setNewPrompt] = useState("");
  const baseColumns = 11;
  const totalColumns = baseColumns + customFields.length;
  const uploadButtonRef = useRef(null);

  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

  const [customFieldPopup, setCustomFieldPopup] = useState({
    visible: false,
    value: "",
    contractKey: "",
    contractId: "",
    x: 0,
    y: 0,
  });
  const popupRef = useRef(null);
  const minWidthPercent = totalColumns * 15;
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;
    setFile(selectedFiles);
    setIsModalOpen(true);
  };

  const [filterApplied, setFilterApplied] = useState(false);
  const navigate = useNavigate();

  const handleFilterApply = (filteredInvoices, filterData) => {
    setinvoices(filteredInvoices);
    setIsFilterApplied(true);
    setFilterType(filterData.filterType);
    setTimeRange(filterData.timeRange);
    setFromDate(filterData.fromDate);
    setToDate(filterData.toDate);
    toggleFilterModal();
  };

  const [filteredFiles, setFilteredFiles] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({
    passport: false,
    id: false,
    visa: false,
    license: false,
  });

  useEffect(() => {
    if (isConnected && !hasOpenedPickerOnce) {
      setHasOpenedPickerOnce(true);
    }
  }, [isConnected, hasOpenedPickerOnce]);

  const handleAddFromDriveClick = () => {
    openPicker(async (docs) => {
      try {
        const files = await Promise.all(
          docs.map(async (doc) => {
            const res = await fetch(
              `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              }
            );
            if (!res.ok) throw new Error("Failed to fetch file from Drive");
            const blob = await res.blob();
            return new File([blob], doc.name, { type: blob.type });
          })
        );
        setFile(files);
        setIsModalOpen(true);
      } catch (err) {
        toast.error("Something went wrong while processing selected files.");
      }
    });
  };

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) {
      setToken(cookieToken);
    }
  }, []);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleConnectGoogleDrive = async () => {
    try {
      const token = await getFreshAccessToken();
      if (!token) throw new Error("No access token found");
      const response = await axios.get(
        `http://localhost:8000/api/auth/google-drive/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data && response.data.auth_url) {
        const fixedRedirectUrl = response.data.auth_url.replace(
          "http%3A%2F%2Flocalhost%3A8000%2Fapi%2Fauth%2Fgoogle-drive%2Fcallback%2F",
          encodeURIComponent(
            "https://stagingbackend.docusensa.com/api/auth/google-drive/callback/"
          )
        );
        window.location.href = fixedRedirectUrl;
      } else {
        showPopup("Error", "Invalid response from server.");
      }
    } catch (error) {
      showPopup("Error", "Failed to connect Google Drive. Please try again.");
    }
  };

  const handleExport = async () => {
    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one invoice to export.");
      return;
    }
    setExportInProgress(true);
    try {
      const response = await api.post(
        `api/v1/idsocr/export-id/`,
        { id_keys: selectedContractKeys },
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoices_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
      setIsBulkDelete(false);
    } catch (error) {
      if (error.response) {
        const message =
          error.response.data?.msg || "Failed to export invoices.";
        showPopup("Error", message);
      } else {
        showPopup("Error", "An unexpected error occurred. Please try again.");
      }
    } finally {
      setExportInProgress(false);
    }
  };

  const handleCancel = () => {
    setSelectedinvoices([]);
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };

  const handleToggleMore = () => {
    if (isActionMenuOpen === "more") {
      setIsActionMenuOpen(null);
    } else {
      const rect = moreButtonRef.current.getBoundingClientRect();
      setDropdownCoords({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX,
      });
      setIsActionMenuOpen("more");
    }
  };

  const handleDeleteField = async (fieldId) => {
    try {
      await api.delete(`/api/v1/idsocr/delete-field/${fieldId}/`);
      await fetchCustomFields();
    } catch (error) {
      console.error("Error deleting field", error);
    } finally {
      setDeletingField(null);
    }
  };

  const handleAddField = async () => {
    if (!fieldName.trim() || !fieldPrompt.trim()) return;
    try {
      setLoadingAddField(true);
      await api.post("/api/v1/idsocr/create-field/", {
        field: fieldName.trim(),
        description: fieldPrompt.trim(),
      });
      setFieldName("");
      setFieldPrompt("");
      await fetchCustomFields();
      await fetchinvoices();
      setFieldCreationSuccess(true);
      setTimeout(() => setFieldCreationSuccess(false), 3000);
      setSelectedTab("manage");
      setIsCustomFieldModalOpen(false);
    } catch (error) {
      console.error("Error adding field", error);
    } finally {
      setLoadingAddField(false);
    }
  };

  const fetchinvoices = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      let url = `api/v1/idsocr/ids/`;
      if (isFilterApplied) {
        url = `api/v1/invoice/filter-invoice/`;
        const params = {
          filter_type: filterType,
          time_range: timeRange,
          from_date: fromDate,
          to_date: toDate,
        };
        const response = await api.get(url, { params });
        setinvoices(response.data.invoices || []);
      } else {
        const response = await api.get(url);
        setinvoices(response.data);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    } finally {
      setLoading(false);
    }
  }, [token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

  const tableBodyRef = useRef(null);
  const scrollToTop = () => {
    if (tableBodyRef.current) tableBodyRef.current.scrollTop = 0;
  };

  const handleSelectAll = () => {
    if (selectedinvoices.length === invoices.length) {
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedinvoices(invoices.map((contract) => contract.id));
      setSelectedContractKeys(invoices.map((contract) => contract.key));
    }
  };

  const filteredinvoices = useMemo(() => {
    const query = searchQuery?.toLowerCase() || "";
    return (invoices || []).filter((invoice) => {
      const invoiceName = invoice?.name?.toLowerCase() || "";
      const customerName =
        invoice?.details?.["Customer name"]?.toLowerCase() || "";
      const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";
      return (
        invoiceName.includes(query) ||
        customerName.includes(query) ||
        vendorName.includes(query)
      );
    });
  }, [invoices, searchQuery]);

  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;
  const currentinvoices = useMemo(() => {
    const indexOfLastContract = currentPage * rowsPerPage;
    const indexOfFirstContract = indexOfLastContract - rowsPerPage;
    return filteredinvoices.slice(indexOfFirstContract, indexOfLastContract);
  }, [filteredinvoices, currentPage, rowsPerPage]);

  const totalPages = useMemo(
    () => Math.ceil(filteredinvoices.length / rowsPerPage),
    [filteredinvoices, rowsPerPage]
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (id, key) => {
    if (selectedinvoices.includes(id)) {
      setSelectedinvoices(
        selectedinvoices.filter((contractId) => contractId !== id)
      );
      setSelectedContractKeys(
        selectedContractKeys.filter((contractKey) => contractKey !== key)
      );
    } else {
      setSelectedinvoices([...selectedinvoices, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  const tbodyRef = useRef(null);
  useEffect(() => {
    const calculateRowsPerPage = () => {
      if (tbodyRef.current) {
        const containerHeight = tbodyRef.current.clientHeight;
        const headerHeight = 52;
        const rowHeight = 44;
        const visibleHeight = containerHeight - headerHeight;
        const calculatedRows = Math.floor(visibleHeight / rowHeight);
        if (calculatedRows > 0) setRowsPerPage(calculatedRows);
      }
    };
    calculateRowsPerPage();
    window.addEventListener("resize", calculateRowsPerPage);
    return () => window.removeEventListener("resize", calculateRowsPerPage);
  }, []);

  useEffect(() => {
    if (token) fetchinvoices();
  }, [
    fetchinvoices,
    token,
    isFilterApplied,
    filterType,
    timeRange,
    fromDate,
    toDate,
  ]);

  useEffect(() => {
    if (isFilterApplied) {
      localStorage.setItem(
        "invoiceFilter",
        JSON.stringify({ filterType, timeRange, fromDate, toDate })
      );
    }
  }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

  const handleUploadSuccess = () => {
    fetchinvoices();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchinvoices();
  };

  const handlePageChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage > 0 && newPage <= totalPages) setCurrentPage(newPage);
  };

  const toggleActionMenu = (index, event) => {
    const menuHeight = 150;
    const rect = event.currentTarget.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    const openUpwards = bottomSpace < menuHeight;

    setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
    setActionMenuPosition({
      top: openUpwards ? rect.top - menuHeight : rect.bottom,
      left: rect.left,
      openUpwards,
    });
  };

  const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

  const handleViewMore = (invoiceKey) =>
    navigate(`/Invoices/Invoice_Details/${invoiceKey}`);

  const enableEdit = (invoice) => {
    if (invoice) {
      setIsActionMenuOpen(null);
      setEditContractId(invoice.id);

      const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const regex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})$/;
        const match = dateString.match(regex);
        if (match) {
          let [_, part1, part2, part3] = match;
          if (part3.length === 2)
            part3 = parseInt(part3) < 50 ? "20" + part3 : "19" + part3;
          const d1 = new Date(`${part3}-${part1}-${part2}`);
          const d2 = new Date(`${part3}-${part2}-${part1}`);
          if (!isNaN(d1.getTime()) && d1.getDate() == part2)
            return d1.toISOString().split("T")[0];
          if (!isNaN(d2.getTime()) && d2.getDate() == part1)
            return d2.toISOString().split("T")[0];
        }
        const parsed = new Date(dateString);
        if (!isNaN(parsed.getTime())) return parsed.toISOString().split("T")[0];
        return "";
      };

      const extractAmountAndCurrency = (amount) => {
        if (!amount) return { value: "", currency: "" };
        const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/);
        if (match)
          return {
            currency: match[1].trim(),
            value: match[2].trim().replace(",", "."),
          };
        return { value: amount, currency: "" };
      };

      const { value, currency } = extractAmountAndCurrency(
        invoice.details?.["Total due amount"]
      );

      setEditedContractData({
        ...invoice,
        details: {
          ...invoice.details,
          DOB: formatDateForInput(invoice.details?.["DOB"]),
          "Date of issue": formatDateForInput(
            invoice.details?.["Date of issue"]
          ),
          "Date of expiry": formatDateForInput(
            invoice.details?.["Date of expiry"]
          ),
          "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
          "Due date": formatDateForInput(invoice.details?.["Due date"]),
          "Total due amount": value,
          Currency: currency,
        },
      });
      setInvoiceName(invoice.name || "");
    } else {
      setEditContractId(null);
      setEditedContractData({});
      setInvoiceName("");
    }
  };

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      fetchCustomFields();
      hasFetched.current = true;
    }
  }, []);

  const fetchCustomFields = async () => {
    try {
      setCustomFieldsLoading(true);
      const res = await api.get("/api/v1/idsocr/list-field/");
      setCustomFields(res.data || []);
    } catch (err) {
      console.error("Error fetching fields", err);
    } finally {
      setCustomFieldsLoading(false);
    }
  };

  const handleApplyField = async () => {
    setIsLoading(true);
    const selectedFieldObj = customFields.find(
      (field) => field.field === selectedField
    );
    const payload = isCreatingNew
      ? {
          new_field: { field: newFieldName, description: newPrompt },
          doc_keys: selectedContractKeys,
        }
      : { field_id: selectedFieldObj?.id, doc_keys: selectedContractKeys };

    if (!isCreatingNew && !payload.field_id) {
      setIsLoading(false);
      return;
    }

    try {
      await api.post("api/v1/idsocr/apply-field/", payload);
      setIsCustomApplyFiledModal(false);
      await fetchinvoices();
      await fetchCustomFields();
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditChange = (fieldPath, value) => {
    if (fieldPath.startsWith("details._custom_fields.")) {
      const key = fieldPath.split(".")[2];
      setEditedContractData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          _custom_fields: {
            ...(prev.details?._custom_fields || {}),
            [key]: value,
          },
        },
      }));
    } else if (fieldPath.startsWith("details.")) {
      const key = fieldPath.split(".")[1];
      setEditedContractData((prev) => ({
        ...prev,
        details: { ...prev.details, [key]: value },
      }));
    } else {
      setEditedContractData((prev) => ({ ...prev, [fieldPath]: value }));
    }
  };

  const handleClickOutside = (event) => {
    if (
      actionMenuRef.current &&
      !actionMenuRef.current.contains(event.target)
    ) {
      setIsActionMenuOpen(null);
    }
    if (
      confirmDeleteVisible &&
      event.target.closest(".popup-overlay") === null &&
      !event.target.closest(".popup-box-delete")
    ) {
      setConfirmDeleteVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmDeleteVisible, isActionMenuOpen]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => setPopupVisible(false);

  const handleDelete = (contractId) => {
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one contract to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const handleEditSave = async (invoiceId, invoiceKey) => {
    const fields = editedContractData.details || {};
    const editedData = {
      DOB: fields["DOB"],
      Name: fields["Name"],
      "Date of issue": fields["Date of issue"],
      "Date of expiry": fields["Date of expiry"],
      Type: fields["Type"],
      Country: fields["Country"],
      "Id / Number": fields["Id / Number"],
      "Issuing Authority": fields["Issuing Authority"],
      _custom_fields: fields["_custom_fields"] || {},
    };

    const payload = { edited_data: editedData };
    if (invoice_name && invoice_name !== editedContractData.name) {
      payload.id_name = invoice_name;
    }

    try {
      const response = await api.post(
        `/api/v1/idsocr/edit-id-details/${invoiceKey}/`,
        payload
      );
      if (response.status === 200) {
        const updated = response.data.data;
        setinvoices((prev) =>
          prev.map((inv) =>
            inv.id === invoiceId
              ? { ...inv, name: invoice_name, details: updated }
              : inv
          )
        );
        setEditContractId(null);
        setRenameSuccessRowId(invoiceId);
        setTimeout(() => setRenameSuccessRowId(null), 3000);
      }
    } catch (error) {
      showPopup("Error", "Failed to update ID. Please try again.");
    }
  };

  const confirmDelete = async () => {
    const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];
    setDeleteInProgress(true);
    try {
      const response = await api.delete(`api/v1/idsocr/id-delete/`, {
        data: { document_ids: idsToDelete },
      });
      const { Deleted_invoices = [], Failed_deletions = [] } = response.data;
      if (Deleted_invoices.length > 0) {
        setinvoices((previnvoices) =>
          previnvoices.filter(
            (invoice) => !Deleted_invoices.includes(invoice.id)
          )
        );
        if (isBulkDelete) {
          setSelectedinvoices([]);
          setSelectedContractKeys([]);
        }
      }
      if (Failed_deletions.length > 0) {
        const failureMessages = Failed_deletions.map(
          (failure) => `Invoice ID ${failure.invoice_id}: ${failure.error}`
        ).join("\n");
        showPopup("Deletion Failed", failureMessages);
      }
    } catch (error) {
      showPopup("Error", "Failed to delete invoice(s). Please try again.");
    } finally {
      setDeleteInProgress(false);
      setConfirmDeleteVisible(false);
      setIsBulkDelete(false);
      setContractToDelete(null);
      fetchinvoices();
    }
  };

  useEffect(() => {
    if (editContractId)
      document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editContractId]);

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      {/* 🚀 FIX: Used the exact same outer layout flex structure from KbFolderPage. No manual inline margins! */}
      <div className="max-w-full overflow-x-hidden flex flex-col flex-grow font-outfit">
        <div>
          <Header
            name="Identity Extraction"
            icon={""}
            isMenuOpen={isMenuOpen}
          />
        </div>

        <div className="w-full px-3 mt-2">
          <div className="w-[99%] ml-1">
            {/* Header Controls Area */}
            <div className="flex justify-between items-center w-full mb-4 mt-[3px]">
              {/* LEFT: Search & Filter */}
              <div className="flex items-center gap-3">
                <div
                  className={`flex items-center w-[310px] h-[40px] pl-[26px] pr-5 gap-[1px] shrink-0 rounded-[20px] bg-white overflow-hidden transition-all duration-200 ${
                    isSearchFocused
                      ? "border border-[#BB42AE]/36 shadow-[0_11px_3px_transparent,0_7px_3px_rgba(0,0,0,0.01),0_4px_2px_rgba(0,0,0,0.05),0_2px_2px_rgba(0,0,0,0.09),0_0_1px_rgba(0,0,0,0.10)]"
                      : "border border-black/10"
                  }`}
                >
                  <img
                    src="/search.svg"
                    alt="Search"
                    className="w-[24px] h-[24px] flex-shrink-0 mr-1"
                  />
                  <input
                    type="text"
                    placeholder="Search Identity Here"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onFocus={() => setIsSearchFocused(true)}
                    onBlur={() => setIsSearchFocused(false)}
                    className="font-outfit text-[14px] font-normal border-none outline-none w-full text-[#171717] bg-transparent whitespace-nowrap placeholder:text-gray-400"
                  />
                </div>

                <button
                  className={`flex items-center justify-center gap-2 h-[40px] px-5 rounded-[24px] bg-white transition-all duration-200 ${
                    isFilterApplied
                      ? "border border-[#BB42AE]/36 shadow-sm"
                      : "border border-black/10"
                  }`}
                  onClick={toggleFilterModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M5.85049 13.3333C5.61438 13.3333 5.41646 13.2535 5.25674 13.0938C5.09702 12.934 5.01716 12.7361 5.01716 12.5V7.5L0.183824 1.33333C-0.0245098 1.05556 -0.0557598 0.763889 0.0900735 0.458333C0.235907 0.152778 0.489379 0 0.85049 0H12.5172C12.8783 0 13.1317 0.152778 13.2776 0.458333C13.4234 0.763889 13.3922 1.05556 13.1838 1.33333L8.35049 7.5V12.5C8.35049 12.7361 8.27063 12.934 8.11091 13.0938C7.95118 13.2535 7.75327 13.3333 7.51716 13.3333H5.85049ZM6.68382 6.91667L10.8088 1.66667H2.55882L6.68382 6.91667Z"
                      fill="#52525B"
                    />
                  </svg>
                  <span>Filter</span>
                </button>
              </div>

              {/* RIGHT: Buttons */}
              <div className="flex items-center gap-3 flex-wrap justify-end">
                {selectedinvoices.length > 0 ? (
                  <>
                    <span className="bg-[#F4EBFF] text-[#7F56D9] text-sm px-3 py-1 rounded-full font-medium">
                      {selectedinvoices.length} Invoice selected
                    </span>
                    <button
                      className="bg-[#7F56D9] text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#6941C6] transition"
                      onClick={() => setIsCustomApplyFiledModal(true)}
                    >
                      <span className="text-white">Apply Custom Field</span>
                    </button>

                    <div className="relative">
                      <button
                        ref={moreButtonRef}
                        onClick={handleToggleMore}
                        className="border border-[#D0D5DD] text-[#344054] text-sm font-medium px-4 py-2 rounded-md flex items-center gap-2 hover:bg-gray-50"
                      >
                        More{" "}
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          viewBox="0 0 24 24"
                        >
                          <path d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {isActionMenuOpen === "more" && (
                        <div
                          className="fixed z-[9999] w-35 bg-white border border-gray-200 rounded-md shadow-md py-1 p-1"
                          style={{
                            top: `${dropdownCoords.top}px`,
                            left: `${dropdownCoords.left}px`,
                          }}
                        >
                          <button
                            onClick={handleExport}
                            disabled={exportInProgress}
                            className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-purple-100 text-[#8B55DD] disabled:opacity-50"
                          >
                            <img
                              src="/export-icon-blue.svg"
                              className="w-4 h-4"
                              alt="Export"
                            />
                            {exportInProgress ? "Exporting..." : "Export"}
                          </button>
                          <button
                            onClick={handleBulkDelete}
                            className="flex items-center gap-2 px-3 py-2 text-sm rounded-md w-full hover:bg-red-100 text-red-600"
                          >
                            <img
                              src="/delete-icon-red.svg"
                              className="w-4 h-4"
                              alt="Delete"
                            />
                            Delete
                          </button>
                        </div>
                      )}
                    </div>

                    <button onClick={handleCancel} className="ml-2">
                      <img
                        src="/cancel_icon.svg"
                        alt="Cancel"
                        className="w-5 h-5"
                      />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="flex items-center gap-2 px-4 py-2 bg-white rounded-[8px] border border-black/10 hover:bg-gray-50 transition-colors"
                      onClick={() => setIsCustomFieldModalOpen(true)}
                    >
                      <img
                        src="/custom-field-icons.svg"
                        className="w-5 h-5"
                        alt="Custom Field"
                      />
                      <span className="text-[#52525B] font-medium text-[14px]">
                        Custom Field
                      </span>
                    </button>

                    <div className="relative">
                      <button
                        ref={uploadButtonRef}
                        className="flex items-center gap-2 px-[22px] py-[9px] bg-[#C95EBE] rounded-[8px] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors shadow-sm"
                        onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                        onMouseEnter={() => {
                          if (uploadButtonRef.current) {
                            const rect =
                              uploadButtonRef.current.getBoundingClientRect();
                            setTooltipCoords({
                              top: rect.top + window.scrollY + 45,
                              left:
                                rect.left + window.scrollX + rect.width - 140,
                            });
                          }
                        }}
                      >
                        <img
                          src="/upload_icon_white.svg"
                          className="w-[18px] h-[18px]"
                          alt="Upload"
                        />
                        <span>Upload</span>
                      </button>

                      {isTooltipVisible && (
                        <div
                          className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-lg"
                          style={{
                            top: `${tooltipCoords.top + 10}px`,
                            left: `${tooltipCoords.left - 50}px`,
                          }}
                          onMouseLeave={() => setIsTooltipVisible(false)}
                        >
                          <div
                            className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
                            onClick={() => {
                              setIsTooltipVisible(false);
                              fileInputRef.current.click();
                            }}
                          >
                            <img
                              src="/upload-icon.svg"
                              alt="Upload"
                              className="w-4 h-4"
                            />{" "}
                            Add from device
                          </div>
                          {!isConnected && (
                            <div
                              className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
                              onClick={() => {
                                setIsTooltipVisible(false);
                                navigate("/account/integration");
                              }}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              <img
                                src={
                                  isHovered
                                    ? "/connect-icon-hover.svg"
                                    : "/connect-icon.svg"
                                }
                                alt="Connect"
                                className="w-4 h-4 transition-all"
                              />{" "}
                              Connect Drive
                            </div>
                          )}
                          {isConnected && (
                            <div
                              className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              onClick={handleAddFromDriveClick}
                            >
                              <img
                                src={
                                  isHovered
                                    ? "/picker-icon-hover.svg"
                                    : "/picker-icon.svg"
                                }
                                alt="Picker"
                                className="w-4 h-4 transition-all"
                              />{" "}
                              Add from Drive
                            </div>
                          )}
                        </div>
                      )}

                      <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        className="hidden"
                        accept=".pdf,.jpeg,.jpg,.png"
                        onChange={handleFileChange}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Table Area */}
            <div className="w-full">
              <div
                className="relative overflow-auto custom-scrollbar"
                style={{ height: "calc(100vh - 240px)" }}
                ref={tbodyRef}
              >
                <table
                  className="w-full table-fixed text-sm text-left border-separate border-spacing-0"
                  style={{ minWidth: `${totalColumns * 14.29}%` }}
                >
                  <thead className="bg-white h-12 text-[#1E1E1E] font-medium">
                    <tr>
                      <th className="w-[40px] px-3 sticky top-0 bg-white z-20 border-b border-black/10 align-middle text-center left-0">
                        <input
                          type="checkbox"
                          className="custom-checkbox mx-auto"
                          style={{
                            appearance: "none",
                            border: "1.5px solid #c0c0c0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            backgroundImage:
                              selectedinvoices.length === invoices.length &&
                              invoices.length > 0
                                ? "url('/checck.svg')"
                                : "none",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "14px 14px",
                            display: "block",
                          }}
                          onChange={handleSelectAll}
                          checked={
                            selectedinvoices.length === invoices.length &&
                            invoices.length > 0
                          }
                        />
                      </th>
                      <th className="min-w-[130px] px-2 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        File Name
                      </th>
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Type
                      </th>
                      <th className="min-w-[180px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Country
                      </th>
                      <th className="min-w-[170px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Issuing Authority
                      </th>
                      {customFields.map((field, index) => (
                        <th
                          key={index}
                          className="min-w-[120px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10"
                        >
                          <span className="inline-flex items-baseline gap-1">
                            {field.field}{" "}
                            <img
                              src="/invoice-bulblogo-invoicee.svg"
                              alt="Bullet Icon"
                              className="ml-1 translate-y-[-2px]"
                            />
                          </span>
                        </th>
                      ))}
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        ID Number
                      </th>
                      <th className="min-w-[170px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Name
                      </th>
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        DOB
                      </th>
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Date of Issue
                      </th>
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                        Date of Expiry
                      </th>
                      <th className="min-w-[130px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10 text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody className="bg-white">
                    {loading ? (
                      <tr>
                        <td
                          colSpan={totalColumns}
                          className="py-20 border-b border-black/10 bg-white"
                        >
                          <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
                            <p className="text-[#52525B] font-outfit text-[15px]">
                              Loading Identity Extractions...
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : invoices.length > 0 ? (
                      currentinvoices.map((contract, index) => (
                        <tr
                          key={index}
                          ref={
                            editContractId === contract.id ? editRowRef : null
                          }
                          className="group cursor-pointer hover:bg-[#F8F3FF] transition-colors h-[44px]"
                          onMouseEnter={() => setHoveredRow(index)}
                          onMouseLeave={() => setHoveredRow(null)}
                          style={{
                            background:
                              hoveredRow === index ? "#F8F3FF" : "transparent",
                          }}
                        >
                          <td className="w-[40px] px-3 py-2 align-middle text-center border-b border-black/10 sticky left-0 z-20 bg-white group-hover:bg-[#F8F3FF]">
                            <input
                              type="checkbox"
                              className="custom-checkbox mx-auto"
                              style={{
                                appearance: "none",
                                border: "1.5px solid #c0c0c0",
                                borderRadius: "4px",
                                cursor: "pointer",
                                width: "18px",
                                height: "18px",
                                backgroundImage: selectedinvoices.includes(
                                  contract.id
                                )
                                  ? "url('/checck.svg')"
                                  : "none",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "14px 14px",
                                display: "block",
                              }}
                              checked={selectedinvoices.includes(contract.id)}
                              onChange={() =>
                                handleCheckboxChange(contract.id, contract.key)
                              }
                            />
                          </td>

                          {editContractId === contract.id ? (
                            <>
                              <td className="px-2 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={invoice_name}
                                  onChange={(e) =>
                                    setInvoiceName(e.target.value)
                                  }
                                  className="edit-contract-name-ocr w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="Enter Name"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={
                                    editedContractData.details?.["Type"] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Type",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocrs w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="Enter Type"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={
                                    editedContractData.details?.["Country"] ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Country",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocr w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="Enter Country"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={
                                    editedContractData.details?.[
                                      "Issuing Authority"
                                    ] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Issuing Authority",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocr w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="Enter Authority"
                                />
                              </td>
                              {customFields.map((fieldObj, index) => {
                                const fieldKey = fieldObj.field;
                                return (
                                  <td
                                    key={index}
                                    className="px-3 py-2 align-middle border-b border-black/10"
                                  >
                                    <input
                                      type="text"
                                      value={
                                        editedContractData.details
                                          ?._custom_fields?.[fieldKey] || ""
                                      }
                                      onChange={(e) =>
                                        handleEditChange(
                                          `details._custom_fields.${fieldKey}`,
                                          e.target.value
                                        )
                                      }
                                      className="edit-contract w-full outline-none border border-gray-200 rounded px-2 py-1"
                                    />
                                  </td>
                                );
                              })}
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={
                                    editedContractData.details?.[
                                      "Id / Number"
                                    ] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Id / Number",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocr w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="ID Number"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="text"
                                  value={
                                    editedContractData.details?.["Name"] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Name",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocr w-full outline-none border border-gray-200 rounded px-2 py-1"
                                  placeholder="Name"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="date"
                                  value={
                                    editedContractData.details?.["DOB"] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.DOB",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocrs w-full outline-none border border-gray-200 rounded px-2 py-1"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="date"
                                  value={
                                    editedContractData.details?.[
                                      "Date of issue"
                                    ] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Date of issue",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocrs w-full outline-none border border-gray-200 rounded px-2 py-1"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10">
                                <input
                                  type="date"
                                  value={
                                    editedContractData.details?.[
                                      "Date of expiry"
                                    ] || ""
                                  }
                                  onChange={(e) =>
                                    handleEditChange(
                                      "details.Date of expiry",
                                      e.target.value
                                    )
                                  }
                                  className="edit-contract-name-ocrs w-full outline-none border border-gray-200 rounded px-2 py-1"
                                />
                              </td>
                              <td className="px-3 py-2 align-middle border-b border-black/10 text-center">
                                <button
                                  onClick={() =>
                                    handleEditSave(contract.id, contract.key)
                                  }
                                  className="icon-button-contract mx-1 hover:bg-gray-100 p-1 rounded transition-colors"
                                >
                                  <img
                                    src="/save-icon-contracttable.svg"
                                    alt="Save"
                                    className="action-icon w-5 h-5"
                                  />
                                </button>
                                <button
                                  onClick={() => setEditContractId(null)}
                                  className="icon-button-contract mx-1 hover:bg-gray-100 p-1 rounded transition-colors"
                                >
                                  <img
                                    src="/cancel-icon-contracttable.svg"
                                    alt="Cancel"
                                    className="action-icon w-5 h-5"
                                  />
                                </button>
                              </td>
                            </>
                          ) : (
                            <>
                              <td className="px-2 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                <div className="relative group cursor-pointer text-[#B793ED] underline">
                                  <span
                                    className="truncate inline-block max-w-[120px]"
                                    onClick={() =>
                                      setSelectedFilePreview(contract)
                                    }
                                  >
                                    {contract.name?.length > 25
                                      ? `${contract.name.slice(
                                          0,
                                          40
                                        )}...${contract.name.slice(-5)}`
                                      : contract.name || "N/A"}
                                  </span>
                                  {renameSuccessRowId === contract.id && (
                                    <div className="fixed top-[400px] left-1/2 transform -translate-x-1/2 z-50 inline-flex items-center gap-2 px-4 py-2 h-[40px] rounded-md border border-gray-200 bg-white shadow-md text-sm text-gray-700">
                                      <img
                                        src="/green-icon-tick.svg"
                                        alt="Success"
                                        className="w-5 h-5"
                                      />
                                      <span>Your changes were applied</span>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Type"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Country"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Issuing Authority"] ||
                                  "N/A"}
                              </td>
                              {customFields.map((fieldObj, index) => {
                                const fieldKey = fieldObj.field;
                                const fieldValue =
                                  contract.details?._custom_fields?.[
                                    fieldKey
                                  ] || "N/A";
                                return (
                                  <td
                                    key={index}
                                    className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10"
                                  >
                                    <span
                                      className="text-[#B793ED] cursor-pointer inline-block max-w-[140px] truncate"
                                      onMouseEnter={(e) => {
                                        const rect =
                                          e.currentTarget.getBoundingClientRect();
                                        setCustomFieldPopup({
                                          visible: true,
                                          value: fieldValue,
                                          contractKey: contract.key,
                                          contractId: contract.id,
                                          x: rect.left + window.scrollX,
                                          y: rect.bottom + window.scrollY + 8,
                                        });
                                      }}
                                      onMouseLeave={() => {
                                        setTimeout(() => {
                                          if (
                                            popupRef.current &&
                                            !popupRef.current.matches(":hover")
                                          ) {
                                            setCustomFieldPopup((prev) => ({
                                              ...prev,
                                              visible: false,
                                            }));
                                          }
                                        }, 150);
                                      }}
                                    >
                                      {fieldValue.length > 10
                                        ? `${fieldValue.slice(0, 10)}...`
                                        : fieldValue}
                                    </span>
                                  </td>
                                );
                              })}
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Id / Number"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Name"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["DOB"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Date of issue"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-[#171717] font-outfit text-[14px] font-medium border-b border-black/10">
                                {contract.details?.["Date of expiry"] || "N/A"}
                              </td>
                              <td className="px-3 py-2 align-middle text-center border-b border-black/10 relative">
                                <div
                                  className="flex items-center justify-center w-8 h-8 mx-auto rounded-full hover:bg-gray-100 transition-colors"
                                  onClick={(e) => toggleActionMenu(index, e)}
                                >
                                  <img
                                    src="./action.svg"
                                    alt="Actions"
                                    className="w-[20px] h-[20px] cursor-pointer"
                                  />
                                </div>
                                {isActionMenuOpen === index && (
                                  <div
                                    className="absolute right-8 top-8 bg-white border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.12)] rounded-[12px] p-1.5 z-[9999] min-w-[150px]"
                                    ref={actionMenuRef}
                                  >
                                    <div
                                      className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors ${
                                        hoveredAction === "edit"
                                          ? "bg-[#FAF9F6] text-[#C95EBE]"
                                          : "text-[#52525B]"
                                      }`}
                                      onMouseEnter={() =>
                                        setHoveredAction("edit")
                                      }
                                      onMouseLeave={() =>
                                        setHoveredAction(null)
                                      }
                                      onClick={() => enableEdit(contract)}
                                    >
                                      <img
                                        src={
                                          hoveredAction === "edit"
                                            ? "./edit-active-contract.svg"
                                            : "./edit.svg"
                                        }
                                        alt="Edit"
                                        className="w-4 h-4"
                                      />
                                      <span className="text-[14px] font-medium">
                                        Edit
                                      </span>
                                    </div>
                                    <div
                                      className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors mt-0.5 ${
                                        hoveredAction === "delete"
                                          ? "bg-[#FFF0F0] text-[#E21919]"
                                          : "text-[#52525B]"
                                      }`}
                                      onMouseEnter={() =>
                                        setHoveredAction("delete")
                                      }
                                      onMouseLeave={() =>
                                        setHoveredAction(null)
                                      }
                                      onClick={() => handleDelete(contract.id)}
                                    >
                                      <img
                                        src={
                                          hoveredAction === "delete"
                                            ? "./delete-active-contract.svg"
                                            : "./delete.svg"
                                        }
                                        alt="Delete"
                                        className="w-4 h-4"
                                      />
                                      <span className="text-[14px] font-medium">
                                        Delete
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </td>
                            </>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={totalColumns}
                          className="py-16 text-center bg-white border-b border-black/10"
                        >
                          <div className="flex flex-col items-center justify-center">
                            <img
                              src="/no-contracts.svg"
                              alt="No Documents Found"
                              className="mb-4 w-[120px] h-[120px]"
                            />
                            <p className="text-[#52525B] font-outfit text-[15px]">
                              Looks like your table is empty!
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {invoices.length > 0 && (
                <div className="flex justify-between items-center py-3 mt-1 text-[#52525B] text-sm">
                  <div className="flex items-center gap-2 border border-gray-200 rounded px-3 py-1">
                    <p>{currentPage}</p>
                  </div>
                  <p>of {totalPages} pages</p>
                  <div className="flex gap-2">
                    <button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                      className="p-1 hover:bg-gray-100 rounded transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <img
                        src="decrease.svg"
                        alt="Previous Page"
                        className="w-4 h-4"
                      />
                    </button>
                    <button
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                      className="p-1 hover:bg-gray-100 rounded transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <img
                        src="increase.svg"
                        alt="Next Page"
                        className="w-4 h-4"
                      />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* MODALS */}
        {popupVisible && (
          <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box bg-white rounded-lg p-6 shadow-xl w-[400px]">
              <h2 className="text-[#171717] font-outfit text-lg font-semibold mb-2">
                {popupTitle}
              </h2>
              <p className="text-[#52525B] font-outfit text-sm mb-4">
                {popupMessage}
              </p>
              <button
                onClick={closePopup}
                className="bg-[#C95EBE] text-white px-4 py-2 rounded-md font-outfit hover:bg-[#b04b9e] transition"
              >
                Close
              </button>
            </div>
          </div>
        )}

        {confirmDeleteVisible && (
          <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box-delete bg-white rounded-lg p-6 shadow-xl w-[440px] text-center">
              <h2 className="text-[#171717] font-outfit text-lg font-semibold mb-2">
                Are you sure you want to delete the selected item?
              </h2>
              <p className="text-[#52525B] font-outfit text-sm mb-6">
                Once deleted, the selected item(s) will be permanently removed.
                This action cannot be undone.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => setConfirmDeleteVisible(false)}
                  disabled={deleteInProgress}
                  className="px-6 py-2 border border-gray-300 rounded-md text-[#52525B] hover:bg-gray-50 font-outfit transition"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  disabled={deleteInProgress}
                  className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-outfit transition"
                >
                  {deleteInProgress ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </div>
        )}

        <UploadModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onUploadSuccess={handleUploadSuccess}
          type={"ocr"}
          file={file}
        />

        <Filter_for_ocr
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          onApply={(filteredResponse) => {
            setinvoices(filteredResponse.documents);
            setFilteredFiles(filteredResponse.documents);
            setIsFilterApplied(true);
            setCurrentPage(1);
          }}
          onClear={(cleared) => {
            setIsFilterApplied(false);
            setinvoices(cleared?.documents || []);
            setCurrentPage(1);
          }}
          setIsFilterApplied={setIsFilterApplied}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />

        {isCustomApplyFieldModal && (
          <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            <div className="relative bg-white rounded-[12px] shadow-lg w-[417px] h-[366px] p-6 font-outfit">
              <div className="flex justify-between items-center">
                <h2 className="text-[#171717] font-semibold text-lg">
                  Apply Custom Field
                </h2>
                <span className="text-[#8B55DD] bg-[rgba(139,85,221,0.08)] text-[14px] rounded px-3 py-1 font-medium">
                  {selectedinvoices.length} Contracts selected
                </span>
                <span
                  onClick={() => setIsCustomApplyFiledModal(false)}
                  className="cursor-pointer text-xl text-gray-500 hover:text-black"
                >
                  ×
                </span>
              </div>
              <div className="flex gap-8 mt-5 items-start">
                <label className="flex items-center gap-2 cursor-pointer text-[#171717] text-sm font-medium">
                  <input
                    type="radio"
                    checked={!isCreatingNew}
                    onChange={() => setIsCreatingNew(false)}
                    className="accent-[#7F56D9] w-4 h-4"
                  />{" "}
                  Select Existing
                </label>
                <label className="flex flex-col cursor-pointer">
                  <div className="flex items-center gap-2 text-[#171717] text-sm font-medium">
                    <input
                      type="radio"
                      checked={isCreatingNew}
                      onChange={() => setIsCreatingNew(true)}
                      className="accent-[#7F56D9] w-4 h-4"
                    />{" "}
                    Create New Field
                  </div>
                  <span className="text-xs text-[#999] ml-6">
                    ({customFields.length}/5 used)
                  </span>
                </label>
              </div>
              {isCreatingNew ? (
                <div className="mt-4">
                  <label className="text-sm font-medium text-[#171717]">
                    Field Name
                  </label>
                  <input
                    className="w-full border border-gray-300 rounded-md p-2 mt-1 text-sm outline-none focus:border-[#C95EBE]"
                    placeholder="Enter field name"
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                  />
                  <label className="text-sm font-medium text-[#171717] mt-3 block">
                    Extraction Prompt
                  </label>
                  <textarea
                    className="w-full border border-gray-300 rounded-md p-2 mt-1 text-sm h-20 resize-none outline-none focus:border-[#C95EBE]"
                    placeholder="Enter prompt"
                    value={newPrompt}
                    onChange={(e) => setNewPrompt(e.target.value)}
                  />
                </div>
              ) : (
                <div className="mt-4">
                  <label className="text-sm font-medium text-[#171717]">
                    Choose Field
                  </label>
                  <div className="mt-1">
                    <CustomDropdown
                      selected={selectedField}
                      onSelect={setSelectedField}
                      options={customFields.map((field) => field.field)}
                    />
                  </div>
                </div>
              )}
              <div className="absolute bottom-4 right-4 flex justify-end gap-3">
                <button
                  className="px-4 py-2 border border-gray-300 rounded-md text-[#52525B] text-sm font-medium hover:bg-gray-50 transition"
                  onClick={() => setIsCustomApplyFiledModal(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={handleApplyField}
                  className={`px-4 py-2 text-white text-sm font-medium rounded-md transition ${
                    isLoading
                      ? "bg-[#D081D9]"
                      : "bg-[#C95EBE] hover:bg-[#b04b9e]"
                  }`}
                >
                  {isLoading ? (
                    <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : isCreatingNew ? (
                    "Create & Apply"
                  ) : (
                    "Apply Field"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {isCustomFieldModalOpen && (
          <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            <div className="bg-white rounded-[12px] shadow-xl w-[500px] p-6 relative font-outfit">
              <button
                className="absolute top-4 right-4 text-2xl text-gray-400 hover:text-black"
                onClick={() => setIsCustomFieldModalOpen(false)}
              >
                ×
              </button>
              <h2 className="text-xl font-semibold text-[#171717] mb-1">
                Custom Fields
              </h2>
              <p className="text-[#52525B] text-sm mb-5">
                You can only create up to 5 custom fields per document.
                <br />
                Deleting a field won’t reset the limit.
              </p>
              <div className="flex border-b border-gray-200 mb-5">
                <button
                  className={`pb-2 px-1 mr-6 text-sm font-medium transition-colors ${
                    selectedTab === "manage"
                      ? "border-b-2 border-[#C95EBE] text-[#C95EBE]"
                      : "text-[#73607B] hover:text-[#171717]"
                  }`}
                  onClick={() => setSelectedTab("manage")}
                >
                  {customFieldsLoading
                    ? "Loading..."
                    : `Manage Fields (${customFields.length}/5)`}
                </button>
                <button
                  className={`pb-2 px-1 text-sm font-medium transition-colors ${
                    selectedTab === "create"
                      ? "border-b-2 border-[#C95EBE] text-[#C95EBE]"
                      : "text-[#73607B] hover:text-[#171717]"
                  }`}
                  onClick={() => setSelectedTab("create")}
                >
                  Create New Field
                </button>
              </div>
              {selectedTab === "create" && (
                <>
                  <label className="text-sm font-medium text-[#171717] flex items-center gap-1">
                    Field name{" "}
                    <img src="/bulb.svg" alt="Hint" className="w-4 h-4" />
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md p-2 mt-1 mb-4 text-sm outline-none focus:border-[#C95EBE] disabled:bg-gray-100"
                    value={fieldName}
                    onChange={(e) => setFieldName(e.target.value)}
                    placeholder={
                      isMaxFieldsReached
                        ? "Maximum 5 fields allowed. Delete one to add new."
                        : "Enter field name"
                    }
                    disabled={isMaxFieldsReached}
                  />
                  <label className="text-sm font-medium text-[#171717] flex items-center gap-1">
                    Extraction Prompt{" "}
                    <img src="/bulb.svg" alt="Hint" className="w-4 h-4" />
                  </label>
                  <textarea
                    className="w-full border border-gray-300 rounded-md p-2 mt-1 mb-4 text-sm h-24 resize-none outline-none focus:border-[#C95EBE] disabled:bg-gray-100"
                    value={fieldPrompt}
                    onChange={(e) => setFieldPrompt(e.target.value)}
                    placeholder={
                      isMaxFieldsReached
                        ? "Maximum limit reached."
                        : "Enter prompts here"
                    }
                    disabled={isMaxFieldsReached}
                  />
                  <button
                    className={`w-full py-2.5 rounded-md text-white font-medium text-sm transition ${
                      isFilled && !loadingAddField && !isMaxFieldsReached
                        ? "bg-[#C95EBE] hover:bg-[#b04b9e]"
                        : "bg-[#E5B5DE] cursor-not-allowed"
                    }`}
                    onClick={handleAddField}
                    disabled={loadingAddField || isMaxFieldsReached}
                  >
                    {loadingAddField ? "Adding..." : "Add Field"}
                  </button>
                </>
              )}
              {selectedTab === "manage" && (
                <div className="min-h-[200px] flex flex-col justify-between">
                  <div className="max-h-[222px] overflow-y-auto pr-2 custom-scrollbar">
                    <div className="flex text-xs font-semibold text-[#73607B] mb-3">
                      <div className="w-[120px]">Field Name</div>
                      <div className="flex-1">Prompt</div>
                    </div>
                    {customFields.length ? (
                      customFields.map((field, index) => (
                        <div
                          key={index}
                          className="border-b border-gray-100 py-3 last:border-0 flex items-start gap-4"
                        >
                          <p
                            className="text-[#171717] text-sm font-medium w-[120px] truncate"
                            title={field.field}
                          >
                            {field.field}
                          </p>
                          <p className="text-[#52525B] text-sm flex-1 break-words">
                            {field.description}
                          </p>
                          <button
                            className="text-red-500 text-sm font-medium flex items-center gap-1 hover:text-red-700 disabled:opacity-50"
                            onClick={() => {
                              setDeletingField(field.id);
                              handleDeleteField(field.id);
                            }}
                            disabled={deletingField === field.id}
                          >
                            {deletingField === field.id
                              ? "Deleting..."
                              : "Delete"}{" "}
                            <img
                              src="/delete-icon-red.svg"
                              alt="Delete"
                              className="w-3.5 h-3.5"
                            />
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500 mt-2 text-center">
                        No custom fields available.
                      </p>
                    )}
                  </div>
                  <div className="mt-4 flex justify-end">
                    <button
                      className="px-6 py-2 bg-[#C95EBE] text-white rounded-md text-sm font-medium hover:bg-[#b04b9e] transition"
                      onClick={async () => {
                        await fetchinvoices();
                        setIsCustomFieldModalOpen(false);
                      }}
                    >
                      Done
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {customFieldPopup.visible && (
          <div
            ref={popupRef}
            className="fixed z-[9999] bg-white border border-gray-200 rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.12)] p-3 font-outfit"
            style={{
              top: `${customFieldPopup.y}px`,
              left: `${customFieldPopup.x}px`,
              maxWidth: "300px",
              width: "max-content",
              whiteSpace: "normal",
            }}
            onMouseEnter={() =>
              setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
            }
            onMouseLeave={() =>
              setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
            }
          >
            <p className="text-[#171717] text-[13px] font-medium break-words leading-relaxed">
              {customFieldPopup.value.length > 80
                ? `${customFieldPopup.value.slice(0, 80)}...`
                : customFieldPopup.value}
            </p>
          </div>
        )}

        {selectedFilePreview && (
          <div
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm"
            onClick={() => setSelectedFilePreview(null)}
          >
            <div
              className="bg-white rounded-lg shadow-xl w-[45vw] h-[65vh] overflow-hidden relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center bg-black/50 text-white rounded-full hover:bg-black/70 transition"
                onClick={() => setSelectedFilePreview(null)}
              >
                ✕
              </button>
              {selectedFilePreview.file_type === "pdf" ? (
                <embed
                  src={selectedFilePreview.pdf_url}
                  type="application/pdf"
                  className="w-full h-full"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-50">
                  <img
                    src={selectedFilePreview.pdf_url}
                    alt={selectedFilePreview.name}
                    className="max-w-full max-h-full object-contain p-4"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ContractTable;
